// src/views/Reports/components/ExpiryHeatmap.jsx
import React from 'react';
import { HeatMap } from '@nivo/heatmap';

const ExpiryHeatmap = ({ data, detailed = false }) => {
  // Process data for heatmap
  const processData = () => {
    const categories = [...new Set(data.map(item => item.category))];
    const today = new Date();
    
    // Group items by category and expiry status
    return categories.map(category => {
      const categoryItems = data.filter(item => item.category === category);
      
      const expired = categoryItems.filter(item => {
        if (!item.expiry_date) return false;
        return new Date(item.expiry_date) < today;
      }).length;
      
      const expiringSoon = categoryItems.filter(item => {
        if (!item.expiry_date) return false;
        const expiryDate = new Date(item.expiry_date);
        const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
        return daysUntilExpiry > 0 && daysUntilExpiry <= (item.permissible_expiry_days || 7);
      }).length;
      
      const notExpiringSoon = categoryItems.filter(item => {
        if (!item.expiry_date) return true;
        const expiryDate = new Date(item.expiry_date);
        const daysUntilExpiry = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
        return daysUntilExpiry > (item.permissible_expiry_days || 7);
      }).length;
      
      return {
        category,
        expired,
        'expiring soon': expiringSoon,
        'not expiring soon': notExpiringSoon
      };
    });
  };

  const heatmapData = processData();
  const keys = ['expired', 'expiring soon', 'not expiring soon'];

  return (
    <div style={{ height: '400px' }}>
      <HeatMap
        data={heatmapData}
        keys={keys}
        indexBy="category"
        margin={{ top: 60, right: 90, bottom: 60, left: 90 }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: -45,
          legend: 'Category',
          legendPosition: 'middle',
          legendOffset: 50
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Expiry Status',
          legendPosition: 'middle',
          legendOffset: -70
        }}
        colors={{
          type: 'diverging',
          scheme: 'red_yellow_green',
          divergeAt: 0.5,
          minValue: 0,
          maxValue: Math.max(...heatmapData.flatMap(d => keys.map(key => d[key])))
        }}
        cellOpacity={1}
        cellBorderWidth={0}
        cellBorderColor={{ from: 'color', modifiers: [['darker', 0.4]] }}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.8]] }}
        legends={[
          {
            anchor: 'right',
            translateX: 80,
            translateY: 0,
            length: 300,
            thickness: 10,
            direction: 'column',
            tickPosition: 'after',
            tickSize: 3,
            tickSpacing: 4,
            tickOverlap: false,
            tickFormat: '>-.2s',
            title: 'Count →',
            titleAlign: 'start',
            titleOffset: 4
          }
        ]}
        animate={true}
        motionConfig="wobbly"
      />
    </div>
  );
};

export default ExpiryHeatmap;